import { actionTypes } from 'redux/actions/api/unregister';

const initialState = {
  deleteSuccess: false,
  remainSuccess: false,
};

const unregisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UNREGISTER_DELETE_SUCCESS:
      return { ...state, deleteSuccess: true, deleteError: null };
    case actionTypes.UNREGISTER_DELETE_FAILURE:
      return { ...state, deleteSuccess: false, deleteError: action.payload.response?.data?.message || 'An error occurred' };
    case actionTypes.UNREGISTER_REMAIN_SUCCESS:
      return { ...state, remainSuccess: true, remainError: null };
    case actionTypes.UNREGISTER_REMAIN_FAILURE:
      return { ...state, remainSuccess: false, remainError: action.payload.response?.data?.message || 'An error occurred' };
    default:
      return state;
  }
};

export default unregisterReducer;